<template>
  <div class="container-table">
    <q-card-section>
      <q-table
        data-cy="indicadores"
        :title=title
        :title-class=titleclass
        :data="indicadores"
        :columns="columns"
        row-key="id"
        :selection="selectionFormat"
        :pagination.sync="pagination"
        :loading="loading"
        :selected.sync="selected"
      >
        <!-- columna Visible -->
        <template v-slot:body-cell-estado="props">
          <q-td
            @input="changeVisibility(props)"
            data-cy="estadoIndicador"
            :props="props"
            key="estado"
          >
            {{props.selected?'Contratado':''}}
          </q-td>
        </template>
        <!-- ID Proveedor -->
        <template v-slot:body-cell-idProveedor="props">
          <q-td key="idProveedor" :props="props">
              {{ props.row.idProveedor }}
          </q-td>
        </template>
        <!-- Indicador -->
        <template v-slot:body-cell-name="props">
          <q-td key="name" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>
        <!-- Índice tematico -->
        <template v-slot:body-cell-indiceTematico="props">
          <q-td key="indiceTematico" :props="props">
            {{ props.row.indiceTematico }}
          </q-td>
        </template>
        <!-- Undidad Medidad -->
        <template v-slot:body-cell-unidadMedida="props">
          <q-td key="unidadMedida" :props="props">
            {{ props.row.unidadMedida }}
          </q-td>
        </template>
        <!-- Periodicidad -->
        <template v-slot:body-cell-periodicidad="props">
          <q-td key="periodicidad" :props="props">
            {{ props.row.periodicidad }}
          </q-td>
        </template>
        <!-- Configuración checkbox head tabla -->
        <template v-slot:header-selection="props">
          <q-checkbox
            color="primary"
            v-model="props.selected"
            @input="changeVisibility()"
          />
        </template>
        <!-- Configuración checkbox body tabla -->
        <template v-slot:body-selection="props">
          <q-checkbox
            data-cy="checkBoxIndicador"
            color="primary"
            v-model="props.selected"
            @input="changeVisibility(props.row)"
          />
        </template>
      </q-table>
    </q-card-section>
  </div>
</template>
<script>
import Loading from '@/components/shared/mixins/Loading.js';

import {
  QCheckbox,
  QTable,
  QTd,
  QCardSection
} from 'quasar';

export default {
  components: {
    QCheckbox,
    QTable,
    QTd,
    QCardSection
  },
  props: {
    isLoading: Boolean,
    indicadoresCiudad: Array,
    selectionFormat: String,
    indicadoresIndiceTematico: Array,
    title: {
      required: false,
      type: String,
      default: () => ''
    },
    titleclass: {
      required: false,
      type: String,
      default: () => 'titleCard'
    }
  },
  mixins: [Loading],
  data () {
    return {
      loading: null,
      indicadoresDataIndice: [],
      indicadores: this.indicadoresIndiceTematico ? this.indicadoresIndiceTematico : [],
      pagination: {
        rowsPerPage: 20
      },
      selected: [],
      columns: [
        {
          name: 'estado',
          label: 'Estado',
          align: 'left',
          field: 'visible',
          sortable: false
        },
        {
          name: 'idProveedor',
          label: 'ID Proveedor',
          align: 'left',
          field: 'idProveedor',
          sortable: true,
          sort: (a, b) => parseInt(a) - parseInt(b)
        },
        {
          name: 'name',
          label: 'Indicador',
          align: 'center',
          field: 'name',
          sortable: true
        },
        {
          name: 'indiceTematico',
          label: 'Índice temático',
          align: 'center',
          field: 'indiceTematico',
          sortable: true
        },
        {
          name: 'unidadMedida',
          label: 'Unidad medida',
          align: 'center',
          field: 'unidadMedida',
          sortable: true
        },
        {
          name: 'periodicidad',
          label: 'Periodicidad',
          align: 'center',
          field: 'periodicidad',
          sortable: true
        }
      ]
    };
  },
  created () {
    this.loading = this.isLoading;
  },
  beforeMount () {
    if (this.indicadoresCiudad && Object.entries(this.indicadoresCiudad).length > 0) {
      this.selected = this.indicadoresCiudad.map((n) => {
        return { id: n };
      });
    }
  },
  watch: {
    indicadoresCiudad () {
      if (this.indicadoresCiudad) {
        this.selected = this.indicadoresCiudad.map((n) => {
          return { id: n };
        });
      }
    },
    indicadoresIndiceTematico () {
      this.indicadores = this.indicadoresIndiceTematico ? this.indicadoresIndiceTematico : [];
    },
    isLoading () {
      this.loading = this.isLoading;
    }
  },
  methods: {
    changeVisibility (datos = 0) {
      this.$eventHub.$emit('viewEditedIndicadores', this.selected.length <= 0 ? [] : this.selected.map((e) => e.id));
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }
    .q-card__section--vert {
      padding: 0 !important;
    }
    .titleCardEdicion{
      margin: 10px 282px 0px 15px;
      font-family: DINPro;
      font-weight: 500;
      font-size: 20px;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.29px;
      color: #474848;
    }
  }
}
</style>
